import { BookingStateEnum } from '@xeetr/types/enums'
import { BaseBookingModel } from '@xeetr/types/models'
import { Calendar, Check, LogOut, UserPlus, X } from 'lucide-react'

import { useBookings } from '../../../hooks/useBookings'
import { CustomEvents } from '../../../types/AnalyticsKeys'
import { TrackedButtonProps } from '../../../types/TrackedButton'
import TrackedButton from '../../commons/TrackedButton'


export const StateColumn = (booking: BaseBookingModel): React.ReactElement => {
  const { updateState } = useBookings()

  const buttonDefaults: TrackedButtonProps = {
    trackingkey: CustomEvents.CHANGE_STATUS_DASHBOARD,
    variant: 'outline',
    size: 'full',
    className: 'rounded-full',
  }

  switch (booking.state?.status) {
    case BookingStateEnum.ACCEPTED:
      return (
        <TrackedButton
          {...buttonDefaults}
          icon={Check}
          tooltip="Einchecken"
          onClick={(e) => {
            e.stopPropagation()
            updateState(booking.id, 'checkin')
          }}
        />
      )
    case BookingStateEnum.OPEN:
      return (
        <TrackedButton
          {...buttonDefaults}
          icon={UserPlus}
          tooltip="Reservierung annehmen"
          onClick={(e) => {
            e.stopPropagation()
            updateState(booking.id, 'accept')
          }}
        />
      )
    case BookingStateEnum.CHECKEDIN:
      return (
        <TrackedButton
          {...buttonDefaults}
          icon={LogOut}
          tooltip="Auschecken"
          onClick={(e) => {
            e.stopPropagation()
            updateState(booking.id, 'checkout')
          }}
        />
      )
    case BookingStateEnum.DECLINED:
      return (
        <TrackedButton {...buttonDefaults} icon={X} tooltip="Ablehnen" disabled severity="danger" />
      )
    case BookingStateEnum.CANCELED:
      return (
        <TrackedButton
          {...buttonDefaults}
          icon={X}
          tooltip="Stornieren"
          disabled
          severity="danger"
        />
      )
    case BookingStateEnum.CHECKEDOUT:
      return <TrackedButton {...buttonDefaults} icon={LogOut} tooltip="Ausgecheckt" disabled />
    case BookingStateEnum.ABSENCE:
      return <TrackedButton {...buttonDefaults} icon={X} tooltip="Abwesenheit" disabled />
    case BookingStateEnum.EVENT:
      return <TrackedButton {...buttonDefaults} icon={Calendar} tooltip="Event" disabled />
    case BookingStateEnum.HOLIDAY:
      return (
        <TrackedButton
          {...buttonDefaults}
          icon={Calendar}
          tooltip="Feiertag"
          disabled
          severity="info"
        />
      )
    default:
      return <TrackedButton {...buttonDefaults} icon={X} tooltip="Löschen" severity="danger" />
  }
}
